module.exports = __webpack_public_path__ + "img/categorias.f5a22003.png";